import moment from 'moment';
import { WEEK } from '@utils/granularity';
import { percentileConfig } from '@utils/metrics/constants';

/**
 * Get allowed percentile values based on the selected date range.
 * If the interval is greater than 7 days, only 'avg' is allowed.
 * Otherwise, all percentile options are available.
 *
 * @param interval - Object containing 'from' and 'to' dates
 * @returns Array of allowed percentile values
 */
export const getAllowedPercentile = (interval): string[] => {
  if (!interval || !interval.from || !interval.to) {
    // If interval is not provided, return all options
    return Object.keys(percentileConfig);
  }

  const { from, to } = interval;
  const diff = moment(to).diff(moment(from), 'm'); // difference in minutes

  // If date range is greater than 7 days (WEEK = 60 * 24 * 7 = 10080 minutes)
  if (diff > WEEK) {
    return ['avg'];
  }

  // Return all available percentile options
  return Object.keys(percentileConfig);
};
